<template>
  <div>
    <generic-container
      :title="$t('organization chart list')"
      icon="list"
      style="margin: 0 15px"
      ref="generic_container"
    >
      <div class="ui very relaxed selection horizontal list">
        <div
          class="item"
          v-for="(itm, idx) in list"
          :key="idx"
          @click="load(itm)"
        >
          <img
            class="ui avatar image"
            src="/images/icons/organization-chart.png"
          />
          <div class="content">
            <div class="header">{{ itm.name }}</div>
            {{ itm.description }}
          </div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "OrganizationChartList",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      list: [],
    };
  },
  computed: {},
  methods: {
    load(itm) {
      let vm = this;
      local_api(vm, "post", "/organization_chart/do-get", { i: itm.uuid })
        .then((r) => {
          vm.$emit("load", r);
          vm.$refs.generic_container.toggle();
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    update(chart) {
      let trgt = this.list.find((n) => n.uuid == chart.uuid);
      if (trgt) {
        trgt.name = chart.name;
        trgt.description = chart.description;
      } else this.list.push(chart);
    },
    delete(uuid) {
      let trgtIdx = this.list.findIndex((n) => n.uuid == uuid);
      if (trgtIdx >= 0) this.list.splice(trgtIdx);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/organization_chart/do-get-list")
      .then((r) => {
        vm.list = r;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
};
</script>

<style></style>
